var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrymyaiSs1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 61.911,
    height: 38.43,
    viewBox: "0 0 61.911 38.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_51653",
    x: 5.891,
    y: 18.165,
    width: 52.288,
    height: 20.266,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_51654",
    x: 8.849,
    y: 0,
    width: 53.062,
    height: 20.266,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Union_50",
    x: 0,
    y: 2.371,
    width: 13.975,
    height: 13.975,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.149
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1443",
    "data-name": "Ellipse 1443",
    cx: 5.488,
    cy: 5.488,
    rx: 5.488,
    ry: 5.488,
    fill: "#009081"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18454",
    "data-name": "Rectangle 18454",
    width: 18.015,
    height: 12.43
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51286",
    "data-name": "Path 51286",
    d: "M706.46,1723.234l1.429-.034.513,1.726-2.4.031Z",
    transform: "translate(-706 -1723.2)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51289",
    "data-name": "Path 51289",
    d: "M599.25,338.347c.12-.259,1.282-.243,1.4,0,.395.849,1.672,5.049,1.693,5.255.029.269.307,1.014-.319,4.193-.657,3.342-1.373,7.093-1.373,7.093l-1.41-.024s-.7-3.728-1.363-7.069c-.626-3.179-.347-3.925-.319-4.193C597.577,343.4,598.853,339.2,599.25,338.347Z",
    transform: "translate(-597.468 -338.159)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51293",
    "data-name": "Path 51293",
    d: "M635.4,1159.5l1.232,6.405,1.566-.006,1.267-6.495Z",
    transform: "translate(-635.4 -1159.4)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1437",
    "data-name": "Ellipse 1437",
    cx: 0.582,
    cy: 0.582,
    rx: 0.582,
    ry: 0.582
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51302",
    "data-name": "Path 51302",
    d: "M981.7,762.092l2.434,1.69s-1.361,2.649,1.664,4.381l.171-1.346.149.012-.263,2.266a4.174,4.174,0,0,0,1.555-5.459,1.224,1.224,0,0,0-.128-.217A4.089,4.089,0,0,0,981.7,762.092Z",
    transform: "translate(-981.7 -761.498)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51308",
    "data-name": "Path 51308",
    d: "M7.218,5.2l-2.86-.773S4.751,1.475,1.319.86l.29,1.325-.145.037L.949,0a4.175,4.175,0,0,0,.37,5.663,1.038,1.038,0,0,0,.194.161A4.09,4.09,0,0,0,7.218,5.2Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51312",
    "data-name": "Path 51312",
    d: "M946.647,769.3l.141.849.082.493.08.067-.036.183-1.708-1.01-.006-.467Z",
    transform: "translate(-945.2 -769.3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51315",
    "data-name": "Path 51315",
    d: "M.514,0,.246.816.089,1.29,0,1.345l.007.187L1.85.8l.078-.46Z",
    transform: "translate(0 0)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28624",
    "data-name": "Group 28624",
    transform: "translate(-705.15 -450.969)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 705.15, 450.97)",
    filter: "url(#Path_51653)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51653-2",
    "data-name": "Path 51653",
    d: "M177.97,112.457H219.08a2.346,2.346,0,0,0,2.327-2.365v-9.326l2.852-2.575H184.21a2.346,2.346,0,0,0-2.326,2.365v9.535a2.346,2.346,0,0,0,2.326,2.365",
    transform: "translate(-169.08 -78.03)",
    fill: "#06233d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 705.15, 450.97)",
    filter: "url(#Path_51654)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51654-2",
    "data-name": "Path 51654",
    d: "M221.3,168.2h-41.8a2.365,2.365,0,0,1-2.366-2.365v-9.326l-2.9-2.575h38.35a2.365,2.365,0,0,1,2.365,2.365v9.535a2.365,2.365,0,0,1-2.365,2.365",
    transform: "translate(-162.39 -151.93)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28624-2",
    "data-name": "Group 28624",
    transform: "translate(706.65 453.84)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -1.5, -2.87)",
    filter: "url(#Union_50)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_50-2",
    "data-name": "Union 50",
    d: "M5.488,0A5.488,5.488,0,1,1,0,5.488,5.488,5.488,0,0,1,5.488,0Z",
    transform: "translate(1.5 2.87)",
    fill: "#009081"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_20116",
    "data-name": "Mask Group 20116",
    transform: "translate(0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    transform: "translate(-4.15 -1.36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28248",
    "data-name": "Group 28248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28247",
    "data-name": "Group 28247"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28246",
    "data-name": "Group 28246",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51264",
    "data-name": "Path 51264",
    d: "M526.923,1187.784a.09.09,0,0,0-.089-.084h-1.689a.044.044,0,0,0-.045.044h0a.044.044,0,0,0,.045.045h1.776S526.923,1187.789,526.923,1187.784Z",
    transform: "translate(-518.776 -1173.397)",
    fill: "#002234",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51265",
    "data-name": "Path 51265",
    d: "M375.15,1050.615l-1.59-1.589a.005.005,0,0,0-.006,0h0l-.029.029a.044.044,0,0,0,0,.063h0l1.529,1.529a.044.044,0,0,0,.063,0h0Z",
    transform: "translate(-369.014 -1036.392)",
    fill: "#002234",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51266",
    "data-name": "Path 51266",
    d: "M499.093,1173.9a.193.193,0,1,1-.193.193A.193.193,0,0,1,499.093,1173.9Zm0,.07a.123.123,0,1,1-.123.123h0A.124.124,0,0,1,499.093,1173.97Z",
    transform: "translate(-492.892 -1159.764)",
    fill: "#002234",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51267",
    "data-name": "Path 51267",
    d: "M930.4,1187.745a.045.045,0,0,1,.045-.045h1.773a.006.006,0,0,1,.006.006h0a.09.09,0,0,1-.089.084h-1.69a.046.046,0,0,1-.045-.046Z",
    transform: "translate(-919.197 -1173.398)",
    fill: "#002234",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51268",
    "data-name": "Path 51268",
    d: "M1099.025,1052.018a.044.044,0,0,1,0-.062h0l1.529-1.53a.044.044,0,0,1,.063,0h0l.031.031-1.59,1.59a.005.005,0,0,1-.006,0h0Z",
    transform: "translate(-1085.777 -1037.764)",
    fill: "#002234",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51269",
    "data-name": "Path 51269",
    d: "M1076.193,1173.9a.193.193,0,1,0,.193.193A.193.193,0,0,0,1076.193,1173.9Zm0,.07a.123.123,0,1,0,.123.123A.123.123,0,0,0,1076.193,1173.97Z",
    transform: "translate(-1063.043 -1159.764)",
    fill: "#002234",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51270",
    "data-name": "Path 51270",
    d: "M579.323,1298.2a.089.089,0,0,1-.089.089h-1.689a.044.044,0,0,1-.045-.044h0a.045.045,0,0,1,.045-.045h1.689a.089.089,0,0,1,.089.089h0Z",
    transform: "translate(-570.545 -1282.567)",
    fill: "#002234",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51271",
    "data-name": "Path 51271",
    d: "M468.686,1308.594l-1.087,1.087a0,0,0,0,1-.007,0h0l-.029-.029a.045.045,0,0,1,0-.062h0l1.027-1.027a.045.045,0,0,1,.063,0h0Z",
    transform: "translate(-461.92 -1292.792)",
    fill: "#002234",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51272",
    "data-name": "Path 51272",
    d: "M551.593,1287.686a.193.193,0,1,0-.193-.193A.193.193,0,0,0,551.593,1287.686Zm0-.07a.123.123,0,1,0-.123-.123h0A.121.121,0,0,0,551.593,1287.616Z",
    transform: "translate(-544.76 -1271.798)",
    fill: "#002234",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51273",
    "data-name": "Path 51273",
    d: "M878,1298.146a.044.044,0,0,0,.045.045h1.774a.006.006,0,0,0,.006-.006h0a.089.089,0,0,0-.089-.084h-1.689a.047.047,0,0,0-.046.046Z",
    transform: "translate(-867.426 -1282.468)",
    fill: "#002234",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51274",
    "data-name": "Path 51274",
    d: "M1046.663,1307.081a.045.045,0,0,0,0,.063h0l1.027,1.027a.045.045,0,0,0,.063,0h0l.031-.031-1.088-1.088a0,0,0,0,0-.007,0h0Z",
    transform: "translate(-1034.046 -1291.31)",
    fill: "#002234",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51275",
    "data-name": "Path 51275",
    d: "M1023.792,1287.686a.193.193,0,1,1,.193-.193A.193.193,0,0,1,1023.792,1287.686Zm0-.07a.123.123,0,1,1,.123-.123h0A.123.123,0,0,1,1023.792,1287.616Z",
    transform: "translate(-1011.273 -1271.798)",
    fill: "#002234",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51276",
    "data-name": "Path 51276",
    d: "M647.147,1326.256l-1.286,1.286a0,0,0,0,1-.006,0h0l-.029-.029a.044.044,0,0,1,0-.063h0l1.226-1.226a.044.044,0,0,1,.063,0h0Z",
    transform: "translate(-638.036 -1310.242)",
    fill: "#002234",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51277",
    "data-name": "Path 51277",
    d: "M635.889,1452.7v1.177h-.044a.045.045,0,0,1-.045-.045v-1.086a.045.045,0,0,1,.045-.045Z",
    transform: "translate(-628.144 -1435.206)",
    fill: "#002234",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51278",
    "data-name": "Path 51278",
    d: "M625.042,1426.842a.193.193,0,1,0-.273,0A.194.194,0,0,0,625.042,1426.842Zm-.049-.049a.123.123,0,1,0-.173,0,.122.122,0,0,0,.173,0Z",
    transform: "translate(-617.189 -1409.334)",
    fill: "#002234",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51279",
    "data-name": "Path 51279",
    d: "M851.925,1324.88a.044.044,0,0,0,0,.063h0l1.226,1.226a.044.044,0,0,0,.063,0h0l.031-.031-1.285-1.285a0,0,0,0,0-.006,0h0Z",
    transform: "translate(-841.653 -1308.896)",
    fill: "#002234",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51280",
    "data-name": "Path 51280",
    d: "M963.845,1452.6a.046.046,0,0,0-.045.045v1.086a.045.045,0,0,0,.045.044h.044V1452.6Z",
    transform: "translate(-952.194 -1435.107)",
    fill: "#002234",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51281",
    "data-name": "Path 51281",
    d: "M950.169,1426.842a.193.193,0,1,1,.273,0A.194.194,0,0,1,950.169,1426.842Zm.049-.049a.123.123,0,1,1,.173,0,.122.122,0,0,1-.173,0Z",
    transform: "translate(-938.671 -1409.334)",
    fill: "#002234",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51282",
    "data-name": "Path 51282",
    d: "M706.46,1723.234l1.429-.034.512,1.726-2.4.031Z",
    transform: "translate(-697.498 -1702.449)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28221",
    "data-name": "Group 28221",
    transform: "translate(8.502 20.751)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28220",
    "data-name": "Group 28220"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28219",
    "data-name": "Group 28219",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51283",
    "data-name": "Path 51283",
    d: "M716.893,1696.066a.2.2,0,1,1-.4,0h0a.207.207,0,0,1-.2.211.2.2,0,0,1-.141-.06.272.272,0,0,1-.3.124h0a.293.293,0,0,1-.2-.351c.092-.39.256-1.091.349-1.48a.277.277,0,0,1,.335-.212h0a.231.231,0,0,1,.183.3l0,.022h.331l0-.022c-.037-.155.072-.264.22-.3h0a.276.276,0,0,1,.335.212c.091.39.256,1.09.349,1.48a.292.292,0,0,1-.2.351h0a.271.271,0,0,1-.3-.126.2.2,0,0,1-.142.063.207.207,0,0,1-.2-.212Z",
    transform: "translate(-715.523 -1694.637)",
    fill: "#fa8d95",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51284",
    "data-name": "Path 51284",
    d: "M809.8,1725.657l.242.012,0-.427.12.42.2-.094-.341-1.267-.226,0Z",
    transform: "translate(-808.55 -1724.287)",
    fill: "#fcc4c8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51285",
    "data-name": "Path 51285",
    d: "M754.97,1725.657l-.242.012,0-.427-.121.42-.2-.094.341-1.267.226,0Z",
    transform: "translate(-753.817 -1724.287)",
    fill: "#fcc4c8",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_51287",
    "data-name": "Path 51287",
    d: "M599.25,338.347c.12-.259,1.282-.243,1.4,0,.395.849,1.672,5.049,1.693,5.255.029.269.307,1.014-.319,4.193-.657,3.342-1.373,7.093-1.373,7.093l-1.41-.024s-.7-3.728-1.363-7.069c-.626-3.179-.347-3.925-.319-4.193C597.577,343.4,598.853,339.2,599.25,338.347Z",
    transform: "translate(-590.273 -334.086)",
    fill: "#fa8d95",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28224",
    "data-name": "Group 28224",
    transform: "translate(7.195 4.072)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28223",
    "data-name": "Group 28223"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28222",
    "data-name": "Group 28222",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51288",
    "data-name": "Path 51288",
    d: "M608.4,1004.1l4.69.028-1.114,8.646-2.4.036Z",
    transform: "translate(-608.268 -996.081)",
    fill: "#f34a58",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18449",
    "data-name": "Rectangle 18449",
    width: 5.255,
    height: 0.1,
    transform: "translate(-0.297 8.019)",
    fill: "#002234"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18450",
    "data-name": "Rectangle 18450",
    width: 5.255,
    height: 0.1,
    transform: "translate(-0.297 10.633)",
    fill: "#002234"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18451",
    "data-name": "Rectangle 18451",
    width: 5.255,
    height: 0.1,
    transform: "translate(-0.297 12.7)",
    fill: "#002234"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18452",
    "data-name": "Rectangle 18452",
    width: 5.255,
    height: 0.1,
    transform: "translate(-0.297 14.767)",
    fill: "#002234"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1433",
    "data-name": "Ellipse 1433",
    cx: 0.629,
    cy: 0.629,
    rx: 0.629,
    ry: 0.629,
    transform: "translate(1.049 0.63)",
    fill: "rgba(249,123,132,0.55)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1434",
    "data-name": "Ellipse 1434",
    cx: 0.629,
    cy: 0.629,
    rx: 0.629,
    ry: 0.629,
    transform: "translate(2.763 0.63)",
    fill: "rgba(249,123,132,0.55)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_51290",
    "data-name": "Path 51290",
    d: "M635.4,1159.5l1.232,6.405,1.566-.006,1.267-6.495Z",
    transform: "translate(-627.748 -1145.438)",
    fill: "#3f5d8d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28227",
    "data-name": "Group 28227",
    transform: "translate(7.652 13.962)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28226",
    "data-name": "Group 28226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28225",
    "data-name": "Group 28225",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51291",
    "data-name": "Path 51291",
    d: "M630.266,1162.714l.022.7-.588.5.353,3.483-.259-3.4.608-.575-.043-.726Z",
    transform: "translate(-629.769 -1162.66)",
    fill: "rgba(0,0,0,0.2)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51292",
    "data-name": "Path 51292",
    d: "M918.836,1162.714l-.022.7.588.5-.353,3.483.259-3.4-.608-.575.043-.726Z",
    transform: "translate(-915.289 -1162.66)",
    fill: "rgba(0,0,0,0.2)",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_51294",
    "data-name": "Path 51294",
    d: "M725.9,1652.962l1.922-.062.02.576-1.921.063Z",
    transform: "translate(-717.159 -1632.996)",
    fill: "#587cb4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1435",
    "data-name": "Ellipse 1435",
    cx: 0.582,
    cy: 0.582,
    rx: 0.582,
    ry: 0.582,
    transform: "translate(8.286 4.747)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28230",
    "data-name": "Group 28230",
    transform: "translate(8.286 4.747)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28229",
    "data-name": "Group 28229"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28228",
    "data-name": "Group 28228",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1436",
    "data-name": "Ellipse 1436",
    cx: 0.582,
    cy: 0.571,
    rx: 0.582,
    ry: 0.571,
    transform: "translate(0.005 -0.281)",
    fill: "#002234"
  })))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1438",
    "data-name": "Ellipse 1438",
    cx: 0.582,
    cy: 0.582,
    rx: 0.582,
    ry: 0.582,
    transform: "translate(10 4.747)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28233",
    "data-name": "Group 28233",
    transform: "translate(10 4.747)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28232",
    "data-name": "Group 28232"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28231",
    "data-name": "Group 28231",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1439",
    "data-name": "Ellipse 1439",
    cx: 0.582,
    cy: 0.571,
    rx: 0.582,
    ry: 0.571,
    transform: "translate(0.005 -0.281)",
    fill: "#002234"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_51295",
    "data-name": "Path 51295",
    d: "M824.011,33.163l-.041-.006a.042.042,0,0,0-.048.035l-.565,3.692a.042.042,0,0,0,.035.048l.036.006s0,0,0,0h0Z",
    transform: "translate(-813.442 -32.758)",
    fill: "#002234",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1441",
    "data-name": "Ellipse 1441",
    cx: 0.284,
    cy: 0.284,
    rx: 0.284,
    ry: 0.284,
    transform: "translate(10.253 0)",
    fill: "#f34a58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51296",
    "data-name": "Path 51296",
    d: "M729.757,33.554a.042.042,0,0,1,.035-.048l.036-.006s0,0,0,0h0l.6,3.766-.041.006a.042.042,0,0,1-.048-.035Z",
    transform: "translate(-720.969 -33.097)",
    fill: "#002234",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1442",
    "data-name": "Ellipse 1442",
    cx: 0.284,
    cy: 0.284,
    rx: 0.284,
    ry: 0.284,
    transform: "translate(8.529 0.01)",
    fill: "#f34a58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51297",
    "data-name": "Path 51297",
    d: "M981.7,762.092l2.434,1.69s-1.361,2.649,1.664,4.381l.171-1.346.149.012-.263,2.266a4.174,4.174,0,0,0,1.555-5.459,1.224,1.224,0,0,0-.128-.217A4.089,4.089,0,0,0,981.7,762.092Z",
    transform: "translate(-969.878 -752.328)",
    fill: "#fa8d95",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28236",
    "data-name": "Group 28236",
    transform: "translate(11.822 9.17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28235",
    "data-name": "Group 28235"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28234",
    "data-name": "Group 28234",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51298",
    "data-name": "Path 51298",
    d: "M955.978,659.455l3.638-.353-4.345-3.2-2.071,1.443v.892Z",
    transform: "translate(-953.543 -657.172)",
    fill: "#f34a58",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51299",
    "data-name": "Path 51299",
    d: "M1030,761.692l.211-1.192",
    transform: "translate(-1029.419 -760.512)",
    fill: "none",
    stroke: "#002234",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51300",
    "data-name": "Path 51300",
    d: "M1100.4,765.781l2.156-1.781",
    transform: "translate(-1098.971 -763.97)",
    fill: "none",
    stroke: "#002234",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51301",
    "data-name": "Path 51301",
    d: "M1169,922.493l3.523-.393",
    transform: "translate(-1166.744 -920.166)",
    fill: "none",
    stroke: "#002234",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_51303",
    "data-name": "Path 51303",
    d: "M7.218,5.2l-2.86-.773S4.751,1.475,1.319.86l.29,1.325-.145.037L.949,0a4.175,4.175,0,0,0,.37,5.663,1.038,1.038,0,0,0,.194.161A4.09,4.09,0,0,0,7.218,5.2Z",
    transform: "matrix(0.719, 0.695, -0.695, 0.719, 6.123, 0.568)",
    fill: "#fa8d95",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28239",
    "data-name": "Group 28239",
    transform: "matrix(0.719, 0.695, -0.695, 0.719, 6.123, 0.568)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28238",
    "data-name": "Group 28238",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28237",
    "data-name": "Group 28237",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51304",
    "data-name": "Path 51304",
    d: "M3.307,0,0,1.555,5.169,3.109,6.633,1.056l-.3-.841Z",
    transform: "translate(1.05 4.427)",
    fill: "#f34a58",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51305",
    "data-name": "Path 51305",
    d: "M0,0,.2,1.195",
    transform: "translate(6.473 4.843)",
    fill: "none",
    stroke: "#002234",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51306",
    "data-name": "Path 51306",
    d: "M1.432,0,0,2.4",
    transform: "translate(4.031 4.533)",
    fill: "none",
    stroke: "#002234",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51307",
    "data-name": "Path 51307",
    d: "M3.186,0,0,1.553",
    transform: "translate(1.324 4.326)",
    fill: "none",
    stroke: "#002234",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_51309",
    "data-name": "Path 51309",
    d: "M596.955,686.511a3.507,3.507,0,0,1-.6-.083,2.99,2.99,0,0,0-1.367,0c-.371.159-.188-.671-.235-.872s-.323-2.341-.307-2.764a7.169,7.169,0,0,1,.455-2.293,2.561,2.561,0,0,0,4.1,0,7.212,7.212,0,0,1,.455,2.293c.017.423-.26,2.563-.307,2.764s.136,1.031-.235.872a2.99,2.99,0,0,0-1.367,0A3.369,3.369,0,0,1,596.955,686.511Z",
    transform: "translate(-587.289 -672.305)",
    fill: "#d2e7e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51310",
    "data-name": "Path 51310",
    d: "M946.549,769.3l.141.849.082.493.079.069-.036.183-1.708-1.01-.007-.467Z",
    transform: "translate(-933.719 -760.036)",
    fill: "#d2e7e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28242",
    "data-name": "Group 28242",
    transform: "translate(11.382 9.264)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28241",
    "data-name": "Group 28241"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28240",
    "data-name": "Group 28240",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51311",
    "data-name": "Path 51311",
    d: "M1083.643,815.7l-.243.778.054.285Z",
    transform: "translate(-1081.735 -815.142)",
    fill: "#001b2a",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_51313",
    "data-name": "Path 51313",
    d: "M.514,0,.246.816.089,1.29,0,1.345l.007.187L1.85.8l.078-.46Z",
    transform: "matrix(0.719, 0.695, -0.695, 0.719, 6.894, 8.186)",
    fill: "#d2e7e3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28245",
    "data-name": "Group 28245",
    transform: "translate(5.829 8.186)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28244",
    "data-name": "Group 28244",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28243",
    "data-name": "Group 28243",
    transform: "matrix(0.719, 0.695, -0.695, 0.719, 1.064, 0)",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51314",
    "data-name": "Path 51314",
    d: "M0,0,.12.807l-.1.273Z",
    transform: "translate(-0.025 0.48)",
    fill: "#001b2a",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_51316",
    "data-name": "Path 51316",
    d: "M634.07,681.914c.877-.082,2.054-1.414,2.054-1.414l.03.1a3.927,3.927,0,0,1-2.091,1.42A3.88,3.88,0,0,1,632,680.6l.03-.1s1.168,1.337,2.035,1.414Z",
    transform: "translate(-624.389 -672.306)",
    fill: "#009081",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18453",
    "data-name": "Rectangle 18453",
    width: 0.071,
    height: 0.275,
    transform: "translate(9.645 9.605)",
    fill: "#009081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51317",
    "data-name": "Path 51317",
    d: "M701.614,812.117a.016.016,0,0,0-.016-.017h-2.482a.026.026,0,0,0-.013,0,.02.02,0,0,0,0,.012v.956a.016.016,0,0,0,.016.017H701.6a.025.025,0,0,0,.013,0,.02.02,0,0,0,0-.012Z",
    transform: "translate(-690.681 -802.321)",
    fill: "#009081",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51318",
    "data-name": "Path 51318",
    d: "M709.91,820.717a.014.014,0,0,0,0-.012.015.015,0,0,0-.012,0h-2.276a.014.014,0,0,0-.012,0,.016.016,0,0,0,0,.012v.747a.014.014,0,0,0,0,.012.016.016,0,0,0,.012,0h2.276a.014.014,0,0,0,.012,0,.016.016,0,0,0,0-.012Z",
    transform: "translate(-699.079 -810.817)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51319",
    "data-name": "Path 51319",
    d: "M722.6,840.786l.037.01a.125.125,0,0,1-.043.072.138.138,0,0,1-.15.006.116.116,0,0,1-.043-.055.2.2,0,0,1-.016-.078.164.164,0,0,1,.017-.079.125.125,0,0,1,.048-.052.14.14,0,0,1,.07-.018.109.109,0,0,1,.112.084l-.037.009a.087.087,0,0,0-.029-.046.073.073,0,0,0-.047-.014.093.093,0,0,0-.055.016.089.089,0,0,0-.031.043.172.172,0,0,0-.01.055.2.2,0,0,0,.011.065.084.084,0,0,0,.033.041.078.078,0,0,0,.048.013.084.084,0,0,0,.054-.019A.071.071,0,0,0,722.6,840.786Z",
    transform: "translate(-713.688 -830.468)",
    fill: "#009081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51320",
    "data-name": "Path 51320",
    d: "M747.2,841.39v-.29h.037v.257h.141v.034Z",
    transform: "translate(-738.202 -830.972)",
    fill: "#009081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51321",
    "data-name": "Path 51321",
    d: "M763.2,841.39l.109-.29h.041l.117.29h-.042l-.034-.088h-.119l-.031.088Zm.082-.119h.1l-.03-.081c-.01-.024-.016-.045-.021-.06a.288.288,0,0,1-.016.055Z",
    transform: "translate(-754.01 -830.972)",
    fill: "#009081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51322",
    "data-name": "Path 51322",
    d: "M784.476,841.39l-.076-.29h.039l.043.19c0,.02.008.04.012.06.007-.031.012-.049.013-.054l.054-.2h.046l.041.147a.745.745,0,0,1,.022.1c0-.018.008-.04.014-.064l.044-.187h.039l-.078.29h-.036l-.06-.222c0-.019-.008-.03-.008-.034l-.008.034-.06.222Z",
    transform: "translate(-774.954 -830.972)",
    fill: "#009081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51323",
    "data-name": "Path 51323",
    d: "M816.8,840.9l.035,0a.076.076,0,0,0,.012.036.061.061,0,0,0,.029.023.11.11,0,0,0,.043.008.124.124,0,0,0,.037-.006.061.061,0,0,0,.025-.018.044.044,0,0,0,.008-.025.042.042,0,0,0-.007-.024.048.048,0,0,0-.026-.017.385.385,0,0,0-.051-.014.236.236,0,0,1-.055-.018.07.07,0,0,1-.04-.064.08.08,0,0,1,.012-.041.078.078,0,0,1,.036-.029.132.132,0,0,1,.052-.01.152.152,0,0,1,.057.011.082.082,0,0,1,.037.03.1.1,0,0,1,.014.046l-.036,0a.057.057,0,0,0-.019-.042.074.074,0,0,0-.049-.014.078.078,0,0,0-.049.013.039.039,0,0,0-.016.031.033.033,0,0,0,.011.025.145.145,0,0,0,.057.02.393.393,0,0,1,.064.019.08.08,0,0,1,.036.03.071.071,0,0,1,.012.041.078.078,0,0,1-.013.043.079.079,0,0,1-.037.031.11.11,0,0,1-.056.011.172.172,0,0,1-.065-.011.089.089,0,0,1-.041-.035A.085.085,0,0,1,816.8,840.9Z",
    transform: "translate(-806.964 -830.576)",
    fill: "#009081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51324",
    "data-name": "Path 51324",
    d: "M838.9,840.849a.161.161,0,0,1,.039-.113.128.128,0,0,1,.1-.041.135.135,0,0,1,.071.019.118.118,0,0,1,.048.054.186.186,0,0,1,0,.158.117.117,0,0,1-.049.053.136.136,0,0,1-.069.018.128.128,0,0,1-.072-.021.131.131,0,0,1-.048-.054A.181.181,0,0,1,838.9,840.849Zm.04,0a.122.122,0,0,0,.028.083.1.1,0,0,0,.135,0s0,0,0,0a.127.127,0,0,0,.028-.087.159.159,0,0,0-.012-.063.088.088,0,0,0-.035-.041.1.1,0,0,0-.051-.014.1.1,0,0,0-.069.028.135.135,0,0,0-.029.1Z",
    transform: "translate(-828.798 -830.57)",
    fill: "#009081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51325",
    "data-name": "Path 51325",
    d: "M865.6,841.39v-.29h.039l.149.229V841.1h.036v.29h-.039l-.149-.229v.229Z",
    transform: "translate(-855.177 -830.972)",
    fill: "#009081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51326",
    "data-name": "Path 51326",
    d: "M768.321,568a.525.525,0,0,1-.49.49.519.519,0,0,1-.484-.452.031.031,0,0,1,.026-.037h.028a.48.48,0,0,0,.43.413.474.474,0,0,0,.425-.392.029.029,0,0,1,.028-.02A.3.3,0,0,1,768.321,568Z",
    transform: "translate(-758.106 -561.16)",
    fill: "#002234",
    fillRule: "evenodd"
  }))))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_51655",
    "data-name": "Path 51655",
    d: "M722.511,456.633h29.273",
    transform: "translate(1.49 0.344)",
    fill: "none",
    stroke: "rgba(6,35,61,0.31)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51658",
    "data-name": "Path 51658",
    d: "M722.511,456.633h29.273",
    transform: "translate(0.396 18.941)",
    fill: "none",
    stroke: "rgba(255,255,255,0.31)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51656",
    "data-name": "Path 51656",
    d: "M722.511,456.633H736.44",
    transform: "translate(1.49 5.814)",
    fill: "none",
    stroke: "rgba(6,35,61,0.31)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51657",
    "data-name": "Path 51657",
    d: "M722.511,456.633h29.273",
    transform: "translate(0.396 24.41)",
    fill: "none",
    stroke: "rgba(255,255,255,0.31)",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrymyaiSs1);
export default __webpack_public_path__ + "static/media/trymyai-ss-1.248af63f05e17fa4b680c73b57a21e73.svg";
export { ForwardRef as ReactComponent };